import React, { FC } from 'react'
import { Col, FlexboxGrid } from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import { getLargePreview } from '../../utils/images'
import { Catalog, Product, Supplier } from '../../utils/types/Product'
import Avatar from '../Avatar/Avatar'
import ChatPanel from '../ChatPanel'
import { getSupplierLogo } from '../../lib/supplier'

import supplierStyles from '../../styles/SupplierCarousel.module.less'
import styles from '../../styles/ProductUnavailable.module.less'

interface ProductUnavailableProps {
  mainTitle: string
  descText: string
  product?: Product
  orderedCategories?: Catalog[]
  supplier?: Supplier
}

const ProductUnavailable: FC<ProductUnavailableProps> = (props) => {
  const { mainTitle, descText, supplier } = props

  const { t } = useTranslation('modals')
  const supplierLogoUrl = getSupplierLogo(supplier?.media)

  return (
    <FlexboxGrid
      align="middle"
      justify="center"
      className={`${styles['product-unavailable-container']} padding-top-spacer`}
    >
      <FlexboxGrid.Item
        as={Col}
        xs={22}
        sm={19}
        md={10}

      >
        {supplier && (
          <FlexboxGrid
            align="middle"
            justify="center"
            className="margin-top-spacer-tripple "
          >
            <FlexboxGrid.Item>
              <div className={`${supplierStyles['supplier-logo']} margin-bottom-spacer-tripple`}>
                <Avatar
                  size="lg"
                  imageSrc={(getLargePreview(supplierLogoUrl))}
                  altName={supplier['supplier.label'] || supplier['supplier.code']}
                />
              </div>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        )}

        <div className="text-center">
          <h4>{mainTitle}</h4>
          <div className="margin-top-spacer-double">
            {descText}
          </div>
        </div>
      </FlexboxGrid.Item>

      <ChatPanel
        className={`${styles['product-unavailable-chat-panel']} margin-top-spacer-tripple`}
        customTextContent={t('modals:Get help from our experts')}
        chatPanelCtaText={t('modals:Chat with us')}
      />
    </FlexboxGrid>
  )
}

export default ProductUnavailable
